module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/finance-menu/finance-menu.component.css
// module id = ./src/app/finance/finance-menu/finance-menu.component.css
// module chunks = main